// @flow

import type {
  DefaultThemeSettingsState,
  DefaultThemeSettingsAction
} from 'stores/flow-type/default-theme-settings.type';

import {
  GET_DEFAULT_THEME_SETTINGS_REQUEST,
  GET_DEFAULT_THEME_SETTINGS_SUCCESS,
  GET_DEFAULT_THEME_SETTINGS_FAILURE,
  UPDATE_DEFAULT_THEME_SETTINGS_REQUEST,
  UPDATE_DEFAULT_THEME_SETTINGS_SUCCESS,
  UPDATE_DEFAULT_THEME_SETTINGS_FAILURE
} from 'stores/flow-type/default-theme-settings.type';

const initialState: DefaultThemeSettingsState = {
  loadingDefaultThemeSettings: false,
  savingDefaultThemeSettings: false,
  success: false,
  error: undefined,
  defaultThemeSettings: {}
};

const defaultThemeSettingsReducers = (
  state: DefaultThemeSettingsState = initialState,
  action: DefaultThemeSettingsAction
) => {
  switch (action.type) {
    case GET_DEFAULT_THEME_SETTINGS_REQUEST:
      return { ...state, loadingDefaultThemeSettings: true };

    case GET_DEFAULT_THEME_SETTINGS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        loadingDefaultThemeSettings: false,
        success: true,
        error: undefined,
        defaultThemeSettings: { ...data }
      };
    }
    case GET_DEFAULT_THEME_SETTINGS_FAILURE:
      return {
        ...state,
        loadingDefaultThemeSettings: false,
        success: false,
        error: action.payload
      };

    case UPDATE_DEFAULT_THEME_SETTINGS_REQUEST:
      return { ...state, savingDefaultThemeSettings: true, success: false };

    case UPDATE_DEFAULT_THEME_SETTINGS_SUCCESS: {
      let defaultThemeSettings = action.payload;
      return {
        ...state,
        savingDefaultThemeSettings: false,
        success: true,
        successSave: true,
        error: undefined,
        defaultThemeSettings
      };
    }

    case UPDATE_DEFAULT_THEME_SETTINGS_FAILURE:
      return {
        ...state,
        savingDefaultThemeSettings: false,
        success: false,
        successSave: false,
        error: action.payload
      };
    default:
      return state;
  }
};
export default defaultThemeSettingsReducers;
